export interface DetailKpiItem {
  label: string;
  value: string;
  sub?: string;
  /** Render the value in brand blue (used for the primary savings metric). */
  highlight?: boolean;
  /** Explicit value colour (e.g. effort severity); overrides `highlight`. */
  color?: string;
}

interface DetailKpiStripProps {
  items: DetailKpiItem[];
}

// Detail-page KPI strip, matched to the "Discover (A)" design (detail.jsx):
// a single card divided into cells (padding 15px 18px), each with an
// uppercase 11px label (mb 8), a 21px/500 value (brand blue when
// highlighted), and a muted 11px sub-line.
export const DetailKpiStrip = ({ items }: DetailKpiStripProps) => {
  return (
    <div
      style={{
        display: "flex",
        overflow: "hidden",
        border: "1px solid #EAECF0",
        borderRadius: 8,
        background: "#fff",
        boxShadow: "0 1px 2px rgba(16,24,40,0.04)",
      }}
    >
      {items.map((item, i) => (
        <div
          key={`${item.label}-${i}`}
          role="group"
          aria-label={item.label}
          style={{ flex: 1, padding: "15px 18px", borderLeft: i ? "1px solid #EAECF0" : "none" }}
        >
          <div
            style={{
              fontSize: 11,
              color: "#667085",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
              fontWeight: 400,
              marginBottom: 8,
            }}
          >
            {item.label}
          </div>
          <div
            aria-label={`${item.label} value`}
            style={{
              fontSize: 21,
              fontWeight: 500,
              color: item.color ?? (item.highlight ? "#247EFE" : "#101828"),
              letterSpacing: "-0.01em",
              fontVariantNumeric: "tabular-nums",
            }}
          >
            {item.value}
          </div>
          {item.sub && (
            <div style={{ fontSize: 11, color: "#98A2B3", marginTop: 4 }}>{item.sub}</div>
          )}
        </div>
      ))}
    </div>
  );
};
